import React, { useEffect, useState } from "react";
import "./Consulting.css";
// import heroimage from "../../assets/heroimage.webp";

const INTRO_TEXT =
  "We transform complex financial and operational data into clear, structured insights that support confident decision-making. Our role is to help businesses, investors, and entrepreneurs understand not just the numbers—but what those numbers truly mean for growth, risk, and value creation.";

const Consulting = () => {
  const [introLength, setIntroLength] = useState(0);
  const [introStarted, setIntroStarted] = useState(false);

  useEffect(() => {
    const start = setTimeout(() => setIntroStarted(true), 400);
    return () => clearTimeout(start);
  }, []);

  useEffect(() => {
    if (!introStarted) return;
    if (introLength >= INTRO_TEXT.length) return;
    const t = setInterval(() => {
      setIntroLength((n) => {
        if (n >= INTRO_TEXT.length) {
          clearInterval(t);
          return n;
        }
        return n + 1;
      });
    }, 35);
    return () => clearInterval(t);
  }, [introStarted, introLength]);

  useEffect(() => {
    const sections = document.querySelectorAll(".animate-on-scroll");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.forEach((section) => observer.observe(section));
    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return (
    <div className="consulting-page">
      {/* Header Section */}
      <div className="header-background">
        <h1 className="page-title animate-on-scroll">
          Real Analysis. <br />
          <span className="highlight-text">Real Growth.</span>
        </h1>

        <div className="intro-section animate-on-scroll">
          <p className="intro-text">
            {INTRO_TEXT.slice(0, introLength)}
            {introLength < INTRO_TEXT.length && (
              <span className="typewriter-cursor" aria-hidden="true">
                |
              </span>
            )}
          </p>
        </div>
      </div>

      {/* Services Section */}
      <div className="services-section animate-on-scroll">
        <h2 className="section-title">OUR CONSULTING SERVICES</h2>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">FS</div>
            <h3>Feasibility Studies & Financial Analysis</h3>
            <p>
              Comprehensive feasibility studies, market assessment, cost analysis, 
              revenue modeling, ROI evaluation, and financial forecasting to 
              support sound investment decisions.
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">IA</div>
            <h3>Investment Advisory & Decision Support</h3>
            <p>
              Opportunity evaluation, risk analysis, project assessment, and 
              executive advisory to help you make informed moves.
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">OP</div>
            <h3>Operations & Process Optimization</h3>
            <p>
              Workflow design, cost efficiency improvement, operational structuring, 
              and system development for streamlined execution.
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">BS</div>
            <h3>Business Consulting & Strategy</h3>
            <p>
              Business diagnostics, strategic planning, restructuring, growth 
              roadmaps, and performance evaluation.
            </p>
          </div>
        </div>
      </div>

      {/* Process Section */}
      <div className="process-section animate-on-scroll">
        <h2 className="section-title">CLARITY FOR DECISIONS</h2>
        <div className="process-steps">
          <div className="step-item">
            <div className="step-number">01</div>
            <h3>DISCOVER → CLARITY</h3>
            <p>Understanding the business, market, and objectives.</p>
          </div>
          <div className="step-item">
            <div className="step-number">02</div>
            <h3>ANALYZE → CONTROL</h3>
            <p>Financial and operational assessment to reduce risk.</p>
          </div>
          <div className="step-item">
            <div className="step-number">03</div>
            <h3>STRUCTURE → ALIGNMENT</h3>
            <p>Building realistic models and execution frameworks.</p>
          </div>
          <div className="step-item">
            <div className="step-number">04</div>
            <h3>DELIVER → GROWTH</h3>
            <p>Clear decisions, measurable results, and scalable impact.</p>
          </div>
        </div>
      </div>

      {/* Industries Section */}
      <div className="industries-section animate-on-scroll">
        <h2 className="section-title">INDUSTRIES WE SERVE</h2>
        <div className="industries-grid">
          {[
            "Real Estate & Construction",
            "Retail & Franchising",
            "Manufacturing & Production",
            "Food & Beverage",
            "Healthcare & Pharmaceuticals",
            "Education & Training",
            "Startups & Entrepreneurs",
            "SMEs & Family Businesses"
          ].map((industry, index) => (
            <div key={index} className="industry-tag">
              {industry}
            </div>
          ))}
        </div>
      </div>

      {/* Why BRG Section */}
      <div className="why-brg-section animate-on-scroll">
        <h2 className="section-title">WHY BRG?</h2>
        <div className="why-grid">
          <div className="why-item">
            <h4>Integrated Consulting</h4>
            <p>Across finance, operations, and strategy.</p>
          </div>
          <div className="why-item">
            <h4>Decision-Ready</h4>
            <p>We deliver actionable outputs, not just reports.</p>
          </div>
          <div className="why-item">
            <h4>Practical Execution</h4>
            <p>Recommendations built for real-world implementation.</p>
          </div>
          <div className="why-item">
            <h4>Regional Experience</h4>
            <p>Expertise across Egypt, KSA, and UAE.</p>
          </div>
          <div className="why-item">
            <h4>Investor Trust</h4>
            <p>Clear financial models that investors rely on.</p>
          </div>
          <div className="why-item">
            <h4>Connected System</h4>
            <p>From insight to impact—one connected system.</p>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Consulting;
